import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import axios from "axios";
import "../admin.css";

const RolePermissionList = () => {
  let [user] = useState(JSON.parse(localStorage.getItem("user")));
  const [rolepermission, setRolePermission] = useState({});
  const [rolecurr, setRoleCurr] = useState([]);

  const [roles, setRoles] = useState([]);

  const [pages, setPages] = useState({ page: 1, size: 200 });
  const [paging, setPaging] = useState(true);
  const [message, setMessage] = useState({
    type: null,
    text: "",
  });

  const handleChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setRoleCurr((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
    //loadPermissions();
  };

  const getRoles = async () => {
    try {
      await axios
        .get(localStorage.getItem("basurl") + "/roles", {
          headers: { "mojo-access-tokens": user.token },
        })

        .then((response) => {
          console.log(response.data);
          setRoles(response.data);
        })
        .catch((err) => {
          setMessage(() => {
            return {
              type: "danger",
              message: err.response.data.message,
            };
          });
        });
    } catch (err) {
      setMessage(() => {
        return {
          type: "danger",
          message: err.message,
        };
      });
    }
  };

  const refreshList = async (e) => {
    loadPermissions();
  };

  const loadPermissions = async () => {
    console.log(rolecurr);
    let user = JSON.parse(localStorage.getItem("user"));
    try {
      await axios
        .get(
          localStorage.getItem("basurl") + "/rolespermissions/" + rolecurr.role,
          {
            headers: {
              "mojo-access-tokens": user.token,
            },
          }
        )
        .then((response) => {
          setRolePermission(() => {
            return response.data;
          });
        })
        .catch((error) => {
          if (
            typeof error.response.data !== undefined &&
            error.response.data.loginRequired
          ) {
            localStorage.removeItem("user");
            window.location.href = "/login";
          }
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const resetMessage = (e) => {
    setMessage(() => {
      return {
        type: null,
        message: "",
      };
    });
  };

  const getMessage = () => {
    if (message.type) {
      return (
        <div className={`alert alert-${message.type}`} role="alert">
          <button type="button" className="close" onClick={resetMessage}>
            <span aria-hidden="true">&times;</span>
          </button>
          <strong className="d-block d-sm-inline-block-force">
            {message.type === "success" ? "Well done!" : "Oops!"}
          </strong>{" "}
          {message.message}
        </div>
      );
    }
  };

  useEffect(() => {
    getRoles();
    loadPermissions();
  }, []);

  return (
    <>
      {getMessage()}

      <label className="col-sm-3 form-control-label">
        Roles: <span className="tx-danger">*</span>
      </label>
      <div className="row">
        <div className="col-sm-4 mg-t-4 mg-sm-t-0">
          <select
            id="role"
            name="role"
            onChange={handleChange}
            placeholder="Please choose your language"
            className="form-control"
            value={rolepermission.role}
          >
            <option key={`role0`} value={0}>
              --select--
            </option>
            {roles.length
              ? roles.map((role) => (
                  <option key={`role` + role.id} value={role.id}>
                    {role.name}
                  </option>
                ))
              : ""}
          </select>
        </div>
        <div className="col-sm-4 mg-t-4 mg-sm-t-0">
          <button
            onClick={refreshList}
            className="pointer ft-right btn-xs alert-info"
          >
            Refresh
          </button>
        </div>
      </div>
      <div className="mg-t-8">
        <>
          <table className="table">
            <thead>
              <tr>
                <th>Id</th>
                <th>Name</th>
                <th>Key Name</th>

                <th>Last Updated</th>
              </tr>
            </thead>
            <tbody>
              {rolepermission.length ? (
                rolepermission.map((item) => (
                  <tr key={"rp" + item.id}>
                    <td>{item.id}</td>
                    <td>{item.name}</td>
                    <td>{item.keyname}</td>
                    <td>
                      <Moment date={item.created_at} local fromNow />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <th className="text-center alert-danger" colSpan={5}>
                    You have not added any role yet.
                  </th>
                </tr>
              )}
            </tbody>
          </table>
        </>
      </div>
    </>
  );
};

export default RolePermissionList;
